import { CommonModule } from '@angular/common'
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgModule } from '@angular/core'

@NgModule({
  imports: [ CommonModule, NgIdleKeepaliveModule.forRoot() ],
  declarations: []
})
export class DataModule { }
